import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { ISearchFilter } from '@shared/interface/search.interface';
import { ERoles } from '@shared/enum';
import { IResponseAll } from '@shared/interface/response.interface';
import { IsampleList } from '@shared/list/sample.list';
import { BehaviorSubject, Observable, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpUSerService {
  private http = inject(HttpClient);
  private urlApi = environment.apiUrl + '/user';

  private sellersSubject = new BehaviorSubject<any[]>([]);
  public sellers$ = this.sellersSubject.asObservable();

  get sellers(): any[] {
    return this.sellersSubject.value;
  }

  getSellers(roles?:string[]): Observable<any[]> {
    return this.sellers$.pipe(
      map(sellers => {
        if (roles?.length) {
          return sellers.filter((s)=>roles.includes(s.role));
        }
        console.log("SELLERS == ", sellers);
        return sellers;
      })
    );
  }

  findAll(filter: ISearchFilter) {
    return this.http.post<any>(`${this.urlApi}/all`, { ...filter });
  }

  find(id: number) {
    return this.http.get<any>(`${this.urlApi}/one/${id}`);
  }

  update(id: number, data: any) {
    this.findListSeller();
    return this.http.patch<any>(`${this.urlApi}/${id}`, { ...data });
  }

  findListSeller() {
    const filter: ISearchFilter = {
      field: ['roles', 'roles', 'roles'],
      valueField: [ERoles.SELLER_ONE, ERoles.SELLER_TWO, ERoles.ADMIN],
      isLike: true,
      orWhere:false,
      limit: 1000,
    };

    const result: IsampleList[] = [];

    this.findAll(filter).subscribe((resp: IResponseAll) => {
      resp.data.forEach((user) => {
        result.push({ id: user.id, name: user.name, role:user.roles[0] });
      });

      this.sellersSubject.next(result);
      console.log("INIT SELLER == ", result);
    });
  }
}
